import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button, Select, MenuItem, TextField, FormControl, InputLabel, Grid } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "src/components/dialogs/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import { asyncRequest } from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import SalaryDialog from "src/components/dialogs/SalaryDialog";
import TitleDialog from "src/components/dialogs/TitleDialog";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import StaffAddDialog from "src/components/dialogs/StaffAddDialog";
import TiejunAddDialog from "./components/TiejunAddDialog";
import { TIEJUN_LEVELS, TIEJUN_LEVEL_MAP } from "src/config/constants";
import BindTeijunParentDialog from "./components/BindTeijunParentDialog";
import TiejunEditDialog from "./components/TiejunEditDialog";
import { exportXlsx } from "src/utils/xlsx.util";

const levels = Object.values(TIEJUN_LEVELS);

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "user", label: "用户", alignRight: false },
  { id: "realname", label: "真实姓名", alignRight: false },
  { id: "mobile", label: "手机号", alignRight: false },
  { id: "idNo", label: "身份证号", alignRight: false },
  { id: "parent", label: "辅导员", alignRight: false },
  { id: "parentUser", label: "辅导员用户", alignRight: false },
  { id: "level", label: "等级", alignRight: false },
  { id: "ratio", label: "提成", alignRight: false },
  // { id: "balance", label: "消费券", alignRight: false },
  // { id: "points", label: "积分", alignRight: false },
  { id: "points", label: "未发放消费券", alignRight: false },
  // { id: "createdAt", label: "注册时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "编辑", icon: personOutline },
  { title: "设置辅导员", icon: personOutline, condition: "pid" },
  // { title: "发工资", icon: personOutline },
  { title: "解除", icon: personOutline },
];

const ratioMap = {
  1: "6%",
  2: "6%",
  3: "5%",
  4: "5%",
  5: "5%",
};

export default function TiejunList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetUser, setTargetUser] = useState({});
  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    uid: null,
    level: null,
  });

  const [form, setForm] = useState({
    uid: "",
    // orgId: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/user/tiejun/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function getMenus(row) {
    return moreMenus.filter((menu) => {
      if (menu.condition) {
        switch (menu.condition) {
          case "pid":
            return !menu.pid;
        }
      }
      return true;
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTargetUser(row);
      setAction("edit");
    } else if (type === "发工资") {
      setTargetUser(row);
      setAction("pay");
    } else if (type === "解除") {
      handleDel(row);
    } else if (type === "设置辅导员") {
      setTargetUser(row);
      setAction("parent");
    }
  };

  function handleDel({ uid }) {
    Confirm({
      message: "确定解除铁军职位吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/user/tiejun/del",
          data: { uid },
        });

        getItems();
      },
    });
  }

  function handleAddStaff() {
    setAction("add");
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const isUserNotFound = items.length === 0;

  async function handleExport() {
    const { data, count } = await asyncRequest({
      path: "/user/tiejun/list",
      data: {
        ...filter,
        page: 0,
        size: 10000,
        // sort: "uid",
        // order: "asc",
      },
    });

    exportXlsx({
      columns: [
        { header: "ID", key: "uid" },
        { header: "手机号", key: "mobile" },
        { header: "姓名", key: "realname" },
      ],
      data: data.map((d) => ({
        ...d,
        // role: USER_ROLE_MA[d.role],
        // level: USER_LEVEL_MAP[d.level],
        // fakeLevel: USER_LEVEL_MAP[d.fakeLevel],
      })),
      // sheetName: 'aaa',
      fileName: "铁军列表.xlsx",
    });
  }

  return (
    <Page title="铁军列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            铁军列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddStaff()}>
            添加铁军
          </Button>
        </Stack>

        <Card>
          {/* <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} /> */}
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onExport={handleExport} onRefresh={getItems}>
            <Grid container>
              <TextField
                style={{ width: 200 }}
                size="small"
                label="用户ID"
                placeholder="用户ID"
                autoComplete="off"
                id="uid"
                value={filter.uid}
                onChange={(e) => {
                  handleFilterChange("uid", e.target.value);
                }}
              />
              <FormControl size="small">
                <InputLabel id="demo-simple-select-label">等级</InputLabel>
                <Select
                  // labelId="demo-simple-select-label"
                  // id="demo-simple-select"
                  label="等级"
                  value={filter.level}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      level: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {[null, ...levels].map((level, idx) => (
                    <MenuItem key={idx} value={level} name={level}>
                      {idx == 0 ? "全部" : TIEJUN_LEVEL_MAP[level]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, uid, parent, user, realname, level, idNo, org, muted, blocked, acceleration, createdAt, mobile } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                           <Checkbox
                             checked={isItemSelected}
                             onChange={(event) => handleClick(event, uid)}
                           />
                         </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell component="th" scope="row">
                          <UserInfo {...user} enablePreview />
                        </TableCell>
                        <TableCell align="left">{realname}</TableCell>
                        <TableCell align="left">{mobile}</TableCell>
                        <TableCell align="left">{idNo}</TableCell>
                        <TableCell align="left">{idNo}</TableCell>
                        <TableCell align="left">
                          {parent ? (
                            <Stack>
                              <Typography fontSize={14}>{parent.realname}</Typography>
                              <Typography fontSize={14}>{parent.mobile}</Typography>
                            </Stack>
                          ) : null}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {parent ? <UserInfo {...parent.user} enablePreview /> : null}
                        </TableCell>
                        <TableCell align="left">{TIEJUN_LEVEL_MAP[level]}</TableCell>
                        <TableCell align="left">{ratioMap[level]}</TableCell>
                        <TableCell align="left">{user.pointsSalary}</TableCell>

                        {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}

                        <TableCell align="right">
                          <MoreMenu spread={true} menus={getMenus(row)} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {action === "add" && (
        <TiejunAddDialog
          action={action}
          open
          staff={targetUser}
          onClose={() => setAction("")}
          onUpdate={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {action === "edit" && (
        <TiejunEditDialog
          action={action}
          open
          tiejun={targetUser}
          onClose={() => setAction("")}
          onUpdate={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {/* <TitleDialog
        open={action === "title"}
        onClose={() => setAction("")}
        onUpdate={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      /> */}

      {action === "parent" && (
        <BindTeijunParentDialog
          open
          onClose={() => setAction("")}
          onReload={() => {
            getItems();
            setAction("");
          }}
          tiejun={targetUser}
        />
      )}
    </Page>
  );
}
